module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-card card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [(!_vm.driver_id) ? _c('div', {
    staticClass: "driver"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Create a new card for your client")]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Driver id")]), _c('selectize-driver', {
    on: {
      "optionSelected": _vm.setDriverId
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Chip id"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.chip_id),
      expression: "body.chip_id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "chip id"
    },
    domProps: {
      "value": (_vm.body.chip_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "chip_id", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Card Active")]), _c('div', {
    staticClass: "switch small"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.enabled),
      expression: "body.enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "enabled",
      "type": "checkbox",
      "name": "enabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.enabled) ? _vm._i(_vm.body.enabled, null) > -1 : (_vm.body.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "enabled", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "enabled", $$c)
        }
      }
    }
  }), _vm._m(0)])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Card name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "card name"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Standard"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.standard),
      expression: "body.standard"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "standard", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("RAW")]), _c('option', [_vm._v("2-ROTATED")])])])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-center"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCard
    }
  }, [_vm._v("Add card")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": "enabled"
    }
  }, [_c('span', {
    staticClass: "show-for-sr"
  }, [_vm._v("Enabled")]), _c('span', {
    staticClass: "switch-active",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Yes")]), _c('span', {
    staticClass: "switch-inactive",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("No")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11350894!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/CreateCard.vue
// module id = 2272
// module chunks = 1